import { useApp } from "../../state/store.ts";
import { controller } from "../../app/controller.ts";
import { guessBlockColour, rgb } from "./blockColours.ts";

/** "minecraft:dark_oak_planks" → "Dark oak planks", "create:andesite_casing" → "Andesite casing (create)" */
export function blockLabel(id: string): string {
  const [ns, path] = id.includes(":") ? id.split(":", 2) : ["minecraft", id];
  const s = path.split("/").pop()!.replace(/_/g, " ").trim();
  const name = s ? s[0].toUpperCase() + s.slice(1) : id;
  return ns === "minecraft" ? name : `${name} (${ns})`;
}

/** A material's swatch: the person's own texture (data: URL) when there is one, else a colour. */
export function swatch(id: string): { img: string | null; colour: string } {
  const m = useApp.getState().mapColoursOnly ? null : controller.material(id);
  const img = m ? controller.materialThumb(m) || null : null;
  const c = controller.blockColour(id) ?? rgb(guessBlockColour(id));
  return { img, colour: `rgb(${c[0]}, ${c[1]}, ${c[2]})` };
}

/** Material list as text, for "Copy list" */
export function materialsAsText(name: string, materials: [string, number][], sourceUrl?: string): string {
  const lines = materials.map(([id, n]) => `${n.toLocaleString("en-US")} × ${blockLabel(id)}${n >= 64 ? ` (${Math.floor(n / 64)} stacks${n % 64 ? ` + ${n % 64}` : ""})` : ""}`);
  return `${name} · materials${sourceUrl ? `\nSource: ${sourceUrl}` : ""}\n${lines.join("\n")}`;
}

/** how detailed the 3D preview of a build of `blocks` blocks is (blocks per drawn cube edge) */
export function previewLod(blocks: number, thumb = false): number {
  if (thumb) return blocks > 1_200_000 ? 4 : blocks > 150_000 ? 2 : 1;
  return blocks > 2_400_000 ? 4 : blocks > 350_000 ? 2 : 1;
}
